<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="考试名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0">
        <el-col :span="12">
          <el-form-item label="封面上传" prop="avatar">
            <imgUpload v-model="ruleForm.avatar"> </imgUpload>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="关联课程" prop="course_uuid">
            <!-- <el-tag>+</el-tag> -->
            <el-select v-model="ruleForm.course_uuid">
              <el-option v-for="item in typeList" :label="item.title" :value="item.uuid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="考试类型" prop="paper_type">
            <el-select v-model="ruleForm.paper_type">
              <el-option :value="1" label="日常考试">日常考试</el-option>
              <el-option :value="2" label="终考">终考</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="考试地点" prop="address">
            <el-input v-model="ruleForm.address"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="考试时间" prop="exam_time">
            <el-date-picker
              v-model="ruleForm.exam_time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="考试人数" prop="exam_people">
            <el-input v-model="ruleForm.exam_people"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="考试总分" prop="total_score">
            <el-input v-model="ruleForm.total_score"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="考试通知" prop="detail">
        <fullEdit v-model="ruleForm.detail"></fullEdit>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { getCouseList, editPaper, addPaper, paperDetail } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  data() {
    return {
      dates: [],
      loading: false,
      typeList: [],
      teacherList: [],
      ruleForm: {
        cate_uuid: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur",
          },
        ],
        avatar: [
          {
            required: true,
            message: "请上传考试封面",
            trigger: "change",
          },
        ],
        banner: [
          {
            required: true,
            message: "请上传直播封面",
            trigger: "change",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入考试通知",
            trigger: "blur",
          },
        ],
        total_score: [
          {
            required: true,
            message: "请输入考试总分",
            trigger: "blur",
          },
        ],
        exam_people: [
          {
            required: true,
            message: "请输入考试人数",
            trigger: "blur",
          },
        ],
        paper_type: [
          {
            required: true,
            message: "请至少考试类别",
            trigger: "change",
          },
        ],
        course_uuid: [
          {
            required: true,
            message: "请选择关联课程",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写考试地点",
            trigger: "blur",
          },
        ],
        exam_time: [
          {
            required: true,
            message: "请选择考试时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    console.log();
    const row = this.$route.query;
    if (row.uuid) {
      this.getDetail(row);
    }
    this.getType();
  },
  methods: {
    async getDetail(row) {
      const res = await paperDetail(row.uuid);

      if (res) {
        if (res.cate instanceof Array) {
          res.cate_uuid = res.cate.map((it) => {
            return it.uuid;
          });
        }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        this.ruleForm = {
          ...res,
          dates: [res.start_time, res.end_time],
        };
        console.log(res);
      }
    },
    getType() {
      getCouseList().then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({
        keyword_search,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    editSave(data, uuid) {
      editPaper(data, uuid).then((res) => {
        console.log(res);
        if (res) {
          if (this.ruleForm.uuid) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$router.go(-1);
        }
      });
    },
    addSave(data) {
      addPaper(data).then((res) => {
        console.log(res);
        if (res) {
          if (this.ruleForm.uuid) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            exam_type: 2,
          };
          if (data.uuid) {
            this.editSave(data, data.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
